import { render, staticRenderFns } from "./ModalIcon.vue?vue&type=template&id=308b0b93"
import script from "./ModalIcon.vue?vue&type=script&lang=js"
export * from "./ModalIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports